<template>
    <v-dialog v-model="getModalImprimirVenda" max-width="720">
        <v-card>
            <v-card-title>Imprimir</v-card-title>
            <v-card-text>
                <v-flex xs12 md12>
                    <v-btn color="primary" outlined block class="mt-2" @click="imprimirVendaCupomNaoFiscal(getVenda.id)"
                        :loading="$store.getters.getOverlay">Cupom não fiscal</v-btn>
                </v-flex>
                <v-flex xs12 md12>
                    <v-btn color="primary" outlined block class="mt-2" @click="setModalGerarNfce(true)"
                        :loading="$store.getters.getOverlay">Gerar NFC-e</v-btn>
                </v-flex>
                <v-flex xs12 md12>
                    <v-btn color="primary" outlined block class="mt-2" @click="setModalGerarNfe(true)"
                        :loading="$store.getters.getOverlay">Gerar NF-e</v-btn>
                </v-flex>
               
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="cadastrarVenda(), setModalImprimirVenda(false)"
                    outlined block>Voltar</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
        <ModalGerarNfe />
        <ModalGerarNfce />
    </v-dialog>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'
    import ModalGerarNfe from '@/pages/nfe/nfe/ModalGerar'
    import ModalGerarNfce from '@/pages/nfe/nfce/ModalGerar'

    export default {
        components: {
            ModalGerarNfe,
            ModalGerarNfce
        },
        computed: {
            ...mapGetters([
                'getModalImprimirVenda',
                'getVenda',
                'getEmpresaSelecionada'
            ])
        },
        methods: {
            ...mapActions([
                'setModalImprimirVenda',
                'imprimirVendaCupomNaoFiscal',
                'setModalGerarNfe',
                'gerarNFCe',
                'cadastrarVenda',
                "setModalGerarNfce"
            ])
        }
    }
</script>